<!--最多支持两级的多选组件-->
<template>
	<ul class="list-body custom-scrollbar">
		<template v-for="item in dataList">
			<li v-if="getNextMethod(item) != undefined">

				<div class="flexStart" @click="$set(openUl,getIdMethod(item),openUl[getIdMethod(item)] == true?false:true)" style="cursor: pointer;">
				
					<img class="icon" :src="getIcon(item)" v-show="item.next.length != 0">
					<img src="../../../../assets/show.png" alt="" v-show="item.next.length == 0">
					 	<img class="icon" :src="getCheckIcon(item)"  @click="checkItem(item)">
					   <p class="nameItem" v-if="item.name">{{item.name}}</p>
					   <p class="nameItem" v-else>{{item.rightname}}</p>
				</div>
				<multipleSelection :ref="getIdMethod(item)+'next'" style="margin-left: 14px;border: 0;height: auto;" v-show="openUl[getIdMethod(item)] == true"
				 :dataList="getNextMethod(item)" :getIdMethod="getIdMethod" 
				 :getNextMethod="getNextMethod"
				  :defaultCheckedIds="defaultCheckedIds" 
				  :editDisableList="editDisableList" 
				  :nowSelectIds="nowSelectIds" 
				  :idToCheckAbleCount="idToCheckAbleCount" 
				  :idToCheckedCount="idToCheckedCount" 
				  :isSon="true"
				 :selectionType="selectionType" @checkItem="nextCheckItem($event,item)" @unCheckItem="nextUnCheckItem($event,item)"></multipleSelection>
			</li>
			<li v-else style="cursor: pointer;" class="flexStart" @click="checkItem(item)">
				
				<img class="icon" :src="getCheckIcon(item)" @click.stop="checkItem(item)" />
				<p class="nameItem">{{item.name}}</p>
			</li>
		</template>
		<!-- <el-tree class="filter-tree" show-checkbox :data="dataList" :props="defaultProps"
                highlight-current
                    ref="tree"  
                   :expand-on-click-node="true"
                  
                    :default-expanded-keys="['3']"
                    node-key="id" 
                  >
                  <template #default="{ node, data }">
                    <span class="custom-tree-node">
                          <img src="../../../../../public/static/image/elTree/1.9.png" v-if="data.entityName=='AppClassType'"/>
                          <img src="../../../../../public/static/image/elTree/2.1.png" v-else/>
                    
                        {{ data.name }}
                        

                
                    </span>
                  </template>
                </el-tree> -->
	</ul>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		name: 'multipleSelection',
		components: {},
		props: {
			selectionType: {
				validator(value) {
					return ['singleGroup', 'singleItem', 'multiple'].includes(value)
				},
				type: String,
				default: 'singleItem'
			},
			dataList: {
				type: Array,
				default () {
					return []
				}
			},
			getIdMethod: {
				type: Function,
				default (item) {
					return item.id
				}
			},
			getNextMethod: {
				type: Function,
				default (item) {
					//返回undefined则是最终级，不会出现展开图标
					if(item.hasOwnProperty('next')){
						return item.next
					}else{
						return undefined
					}
				}
			},
			defaultCheckedIds: {
				type: Array,
				default () {
					return []
				}
			},
			nowSelectIds: {
				type: Object,
				default () {
					return {}
				}
			},
			idToCheckAbleCount: {
				type: Object,
				default () {
					return {}
				}
			},
			idToCheckedCount: {
				type: Object,
				default () {
					return {}
				}
			},
			isSon: {
				//判断是否非第一级的组件，用于刷新总数
				type: Boolean,
				default: false
			},
			editDisableList: {
				type: Array,
				default(){
					return []
				}
			}
		},
		data() {
			return {
				openUl: {},
				defaultProps: {
                    label: "name",
                    children: 'next'
                    },
			}
		},
		created() {},
		mounted() {
			if (!this.isSon) {
				// console.log("this.dataList弹窗",this.dataList);

				this.setNowCheckedIds(this.defaultCheckedIds)
				this.refreshCheckAbleCount(this.dataList)
				this.refreshCheckedCount(this.dataList)
				//打开第一个列表(如果是列表)
				if (this.dataList[0]!=undefined && this.getNextMethod(this.dataList[0]) != undefined) {
					this.$set(this.openUl,this.getIdMethod(this.dataList[0]),true)
				}
			}
		},
		destroyed() {},
		computed: {
			getBackgroudImageStyle() {
				return resourcesStore.getters.getBackgroudImageStyle
			},
			getBackgroudColorStyle() {
				return resourcesStore.getters.getBackgroudColorStyle
			},
			getResourcesByName() {
				return resourcesStore.getters.getResourcesByName
			},
			getColorById() {
				return resourcesStore.getters.getColorById
			},
			getColorStyleById() {
				return resourcesStore.getters.getColorStyleById
			},
			getIcon() {
				return item => {
					return resourcesStore.getters.getResourcesByName('/multipleSelection/' + (this.openUl[this.getIdMethod(item)] ==
							true ? 'icon_down.png' : 'icon_up.png'))
				}
			},
			getCheckIcon() {
				return nItem => {
					if(nItem == 'all'){
						return resourcesStore.getters.getResourcesByName('/checkBox/' + (this.nowAllSelected ? 'icon_checked.png' : 'icon_uncheck.png'))
					}else{
						return resourcesStore.getters.getResourcesByName('/checkBox/' + (this.nowSelectIds[this.getIdMethod(nItem)] ==
								true ? 'icon_checked.png' : 'icon_uncheck.png'))
					}
				}
			},
		},
		watch: {
			radioVal(nv){
				console.log(nv);
			},
			defaultCheckedIds(nv, ov) {
				if (!this.isSon) {
					this.setNowCheckedIds(nv)
				}
			},
			dataList(nv, ov) {
				if (!this.isSon) {
					// console.log("nv",nv);
					this.refreshCheckAbleCount(nv)
					if (nv[0]!=undefined && this.getNextMethod(nv[0]) != undefined) {
						this.$set(this.openUl,this.getIdMethod(nv[0]),true)
					}
				}
			},
			nowSelectIds(nv, ov) {
				if (!this.isSon) {
					this.refreshCheckedCount(this.dataList)
				}
			}
		},
		methods: {
			 //树形结构选中
            handleCheckChange(){
                
                let nowCheckNodes = this.$refs.tree.getCheckedNodes()
                this.nowCheckNodes = 
                    nowCheckNodes.filter(item => {
                        return item.entityName == 'VirtualDevice';
                })
            },
			getNowCheckList() {
				//取出所有被选中的对象列表,由外部调用
				var idList = []
				eachObject(this.nowSelectIds, (value, id) => {
					if (value == true) {
						idList.push(id)
					}
				})
				//递归从数据列中获取所有选中的id的对象
				var resultList = []
				for (var i = 0, len = this.dataList.length; i < len; i++) {
					var item = this.dataList[i]
					if (idList.includes(this.getIdMethod(item))) {
						resultList.push(item)
					}
					//获取下一级的
					var nextBean = this.$refs[this.getIdMethod(item) + 'next']
					if (nextBean != undefined && nextBean[0] != undefined) {
						resultList.addAll(nextBean[0].getNowCheckList())
					}
				}
				return resultList
			},
			setNowCheckedIds(ids) {
				//先移除所有选中
				eachObject(this.nowSelectIds, (item, key) => {
					this.$delete(this.nowSelectIds, key)
				})
				// console.log("测试看法",ids);
				if (ids != undefined) {
					for (var i = 0, len = ids.length; i < len; i++) {
						var item = ids[i]
						this.$set(this.nowSelectIds, item, true)
					}
				}
			},
			setEditDisableList(list) {
				for(let i = this.editDisableList.length;i >= 0;i--){
					this.$delete(this.editDisableList, i)
				}
				if(list){
                   for(let i = 0;i < list.length;i++){
					this.$set(this.editDisableList, i, list[i])
				}
				}
				
			},
			checkItem(item) {
				
				// if(!isempty(this.editDisableList) && this.editDisableList.indexOf(item.id) > -1){
				// 	// console.log("进来这里");
				// 	return
				// }
				
				if (this.nowSelectIds[this.getIdMethod(item)] == true) {
					// console.log("取消",item);
					this.$delete(this.nowSelectIds, this.getIdMethod(item))
					if (this.selectionType == 'multiple') {
						this.$emit('unCheckItem', item)
					}
					if(item.next.length != 0){ 
						item.next.forEach(t => {
							this.$delete(this.nowSelectIds, this.getIdMethod(t))
								if (this.selectionType == 'multiple') {
									this.$emit('unCheckItem', t)
								}
						})
					}
				} else {
					// console.log("选中",item);
					
					if (this.selectionType != 'multiple') {
						//单选时取消其他选中
						eachObject(this.nowSelectIds, (item, key) => {
							this.$delete(this.nowSelectIds, key)
						})
					}
					this.$set(this.nowSelectIds, this.getIdMethod(item), true)
					if (this.selectionType == 'multiple') {
						this.$emit('checkItem', item)
					}
					if(item.next.length != 0){
						item.next.forEach(t => {
							 if (this.selectionType != 'multiple') {
					        	//单选时取消其他选中
									eachObject(this.nowSelectIds, (item, key) => {
										this.$delete(this.nowSelectIds, key)
									})
								}
								this.$set(this.nowSelectIds, this.getIdMethod(t), true)
								if (this.selectionType == 'multiple') {
									this.$emit('checkItem', t)
								}
						})
					}
				}
			},
			checkGroup(group) {
				console.log("checkGroup",group);
				if(!isempty(this.editDisableList) && this.editDisableList.indexOf(group.id) > -1){
					return
				}
				var checkAll = (list,value) => {
					for (var i = 0, len = list.length; i < len; i++) {
						var item = list[i]
						var next = this.getNextMethod(item)
						if (next != undefined) {
							checkAll(next, value)
						}
						this.$set(this.nowSelectIds, this.getIdMethod(item), value)
					}
				}
				//选中了组
				switch (this.selectionType) {
					case 'singleGroup':
						eachObject(this.nowSelectIds, (group, key) => {
							this.$delete(this.nowSelectIds, key)
						})
						this.$set(this.nowSelectIds, this.getIdMethod(group), true)
						break
					case 'multiple':
						if (this.nowSelectIds[this.getIdMethod(group)] == true) {
							//取消本级和所有下级的选中
							this.$set(this.nowSelectIds, this.getIdMethod(group), false)
							checkAll(this.getNextMethod(group),false)
							this.$emit('unCheckItem', group)
						} else {
							//选中本级别和所有下级
							this.$set(this.nowSelectIds, this.getIdMethod(group), true)
							checkAll(this.getNextMethod(group),true)
							this.$emit('checkItem', group)
						}
						break
				}
			},
			refreshCheckAbleCount(list) {
				for (var i = 0, len = list.length; i < len; i++) {
					var item = list[i]
					this.getCheckAbleCount(item)
				}
			},
			getCheckAbleCount(data) {
				var id = this.getIdMethod(data)
				var next = this.getNextMethod(data)
				if (next == undefined || next.length == 0) {
					this.$set(this.idToCheckAbleCount, id, 0)
					return 0
				}
				var count = 0
				for (var i = 0, len = next.length; i < len; i++) {
					var item = next[i]
					if (this.getNextMethod(item) == undefined) {
						count++
					} else {
						count += this.getCheckAbleCount(item)
						if (this.selectionType == 'singleGroup') {
							count++
						}
					}
				}
				this.$set(this.idToCheckAbleCount, id, count)
				return count
			},
			refreshCheckedCount(list) {
				for (var i = 0, len = list.length; i < len; i++) {
					var item = list[i]
					this.getCheckedCount(item)
				}
			},
			getCheckedCount(data) {
				// console.log("测试",data);
				var id = this.getIdMethod(data)
				var next = this.getNextMethod(data)
				if (next == undefined || next.length == 0) {
					this.$set(this.idToCheckedCount, id, 0)
					return 0
				}
				var count = 0
				for (var i = 0, len = next.length; i < len; i++) {
					var item = next[i]
					if (this.getNextMethod(item) == undefined) {
						if (this.nowSelectIds[this.getIdMethod(item)] == true) {
							count++
						}
					} else {
						if (this.selectionType == 'singleGroup' && this.nowSelectIds[this.getIdMethod(item)] == true) {
							count++
						}
						count += this.getCheckedCount(item)
					}
				}
				this.$set(this.idToCheckedCount, id, count)
				
				return count
			},
			nextCheckItem(item, group) {
				//下级选中了某个项
				//如果下级全选中了，本级别也选中
				// if (this.getNextMethod(group).find(i => this.nowSelectIds[this.getIdMethod(i)] != true) == undefined) {
					// console.log("下级选中测试",group);
					this.$set(this.nowSelectIds, this.getIdMethod(group), true)
					this.$emit('checkItem', group)
				// }
			},
			nextUnCheckItem(item, group) {
				// console.log("下级取消测试",group);
				// this.$set(this.nowSelectIds, this.getIdMethod(group), false)
				// this.$emit('unCheckItem', group)
			}

		}
	}
</script>

<style scoped>
	.list-body {
		background: white;
		border: silver 1px solid;
		border-radius: 5px;
		overflow-y: auto;
		height: 200px;
	}

	.nameItem {
		padding: 8px 0;
	}

	.list-body>li {
		padding: 0 8px;
		/* border-bottom: 1px silver dashed; */
		border-bottom: 1px solid #e6e6e6;
	}

	.list-body>li:last-child {
		border: 0;
	}

	.icon {
		width: 15px;
		height: 15px;
		margin-right: 5px;
	}
</style>
